import { render, staticRenderFns } from "./email-recepients.vue?vue&type=template&id=5d9aa0ac&scoped=true"
import script from "./email-recepients.vue?vue&type=script&lang=js"
export * from "./email-recepients.vue?vue&type=script&lang=js"
import style0 from "./email-recepients.vue?vue&type=style&index=0&id=5d9aa0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9aa0ac",
  null
  
)

export default component.exports